import { ArrowRight, CheckCircle2 } from "lucide-react";
import Navbar from "@/components/Navbar";
import ClientMarquee from "@/components/ClientMarquee";
import Industries from "@/components/Industries";
import Results from "@/components/Results";
import Testimonials from "@/components/Testimonials";
import BookingForm from "@/components/BookingForm";
import FAQ from "@/components/FAQ";
import Footer from "@/components/Footer";
import { usePageSEO } from "@/hooks/usePageSEO";

const PAGE_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "Gary Zelesky",
  "jobTitle": "Dental Keynote Speaker",
  "description": "Nationally recognized dental keynote speaker with 30+ years of experience speaking at AAO, AACD, Hinman, Chicago Midwinter, Seattle Study Club, Pacific Northwest Dental Conference, RDH Under One Roof, and dental schools including University of the Pacific, UCLA, University of Michigan, and Marquette.",
  "url": "https://garyzelesky.com/dental-keynote-speaker",
  "knowsAbout": [
    "Dental keynote speaking",
    "Dental team engagement",
    "Patient experience",
    "Referral relationships",
    "Practice culture",
    "Dental practice leadership",
    "Hygiene team motivation",
    "Specialty practice growth"
  ]
};

export default function DentalSpeakerPage() {
  usePageSEO({
    title: "Dental Keynote Speaker | Gary Zelesky — 30+ Years Speaking at AAO, Hinman, AACD",
    description: "Gary Zelesky is a nationally recognized dental keynote speaker with 30+ years of experience speaking at AAO, AACD, Hinman, Chicago Midwinter, Seattle Study Club, RDH Under One Roof, Pacific Northwest Dental, and dental schools nationwide.",
    canonical: "https://garyzelesky.com/dental-keynote-speaker",
    schema: PAGE_SCHEMA,
    schemaId: "dental-page-schema",
  });

  return (
    <div data-testid="dental-page" className="bg-[#050505] text-white">
      <Navbar />
      <section className="relative pt-40 pb-20 px-6 md:px-10 grain overflow-hidden">
        <div className="absolute inset-0 z-0">
          <img src="/images/gary-banquet.jpg" alt="Gary Zelesky speaking at a dental keynote banquet" className="w-full h-full object-cover opacity-15" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#050505]/70 to-[#050505]" />
        </div>
        <div className="relative max-w-7xl mx-auto z-10">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-[2px] w-12 bg-[#EC1985]" />
            <span className="eyebrow">Dental Industry · 30+ Years · 5+ Countries</span>
          </div>
          <h1 className="h-display text-5xl md:text-7xl lg:text-8xl max-w-5xl">
            The Dental Keynote<br />
            Speaker the <span className="text-[#EC1985]">industry</span><br />
            keeps inviting back.
          </h1>
          <p className="mt-8 text-white/85 text-lg md:text-xl max-w-2xl">
            For 30+ years Gary has spoken for dental conferences, specialty practices,
            study clubs, dental schools, and manufacturers across the United States
            and internationally. Documented ratings. Repeat bookings. Real outcomes.
          </p>

          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-4 max-w-3xl">
            {[
              "30+ years in dental",
              "Repeat clients in every specialty",
              "AAO · AACD · Hinman · Seattle Study Club",
            ].map((t) => (
              <div key={t} className="flex items-center gap-3 text-white/85">
                <CheckCircle2 size={18} className="text-[#EC1985] flex-shrink-0" />
                <span className="text-sm">{t}</span>
              </div>
            ))}
          </div>

          <div className="mt-12">
            <a href="#book" className="btn-primary" data-testid="dental-hero-cta">
              Book Gary for Your Dental Event <ArrowRight size={18} />
            </a>
          </div>
        </div>
      </section>

      <ClientMarquee />
      <Industries />
      <Results />
      <Testimonials />
      <BookingForm />
      <FAQ />
      <Footer />
    </div>
  );
}
